export const errorDefinitions = [
  {
    ident: "error_chic_email_verification_needed",
    title: "Gib uns noch einen Moment",
    desc: "Aufgrund der hohen Last auf unseren Servern benötigen wir mehr Zeit, um Ihr Konto zu aktivieren. Bitte warten Sie ein paar Minuten und versuchen Sie dann, sich mit dem soeben eingegebenen Passwort anzumelden.",
    button: "Close",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
    logout: true,
  },
  {
    ident: "error_value_not_recognized",
    title: "Ungültige Daten im Feld",
    desc: "Bitte überprüfen Sie, ob die richtigen Daten für dieses Feld eingegeben wurden.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_story_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_slider_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_registration_failed",
    title: "Registrierung fehlgeschlagen",
    desc: "Entschuldigung, etwas ist bei der Registrierung schiefgelaufen. Bitte versuchen Sie es erneut.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_consumer_multiple_found",
    title: "Registrierung fehlgeschlagen",
    desc: "Die von Ihnen angegebenen Daten sind mit zwei verschiedenen Konten im eSmoking Club oder AlterCloud verknüpft. Bitte löschen Sie eines dieser Konten, bevor Sie sich beim Inspiration Club registrieren, oder verwenden Sie Daten, die nur mit einem Konto übereinstimmen.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_purchase_value_exceeded",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_prize_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  // old
  // {
  //   ident: "error_prize_already_used",
  //   title: "Das kannst du nicht tun",
  //   desc: "Der Preis für die erfolgreiche Empfehlung wurde bereits zuvor von Ihnen eingelöst. Empfehlen Sie mehr Personen, um weitere Preise zu erhalten.",
  //   button: "Ok",
  //   returnUrl: null,
  //   disableClose: false,
  //   updateUserData: false,
  // },
  {
    ident: "error_periodic_limit_exceeded",
    title: "Du kannst es nicht tun",
    desc: "Es scheint, als hast du diesen Gutschein diese Woche bereits eingelöst. Komme nächste Woche wieder zurück, um ihn wieder einzulösen.",
    button: "Vielen Dank",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_otp_not_confirmed",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_notification_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_not_enough_points",
    title: "Nicht genügend Punkte",
    desc: "Du hast noch nicht genügend Punkte auf deinem Konto, um diesen Gutschein einzulösen. Bitte sammel mehr Punkte und komme erneut zurück.",
    button: "Aktivitätsliste",
    returnUrl: "/activities",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_mobile_phone_taken",
    title: "Telefonnummer bereits vergeben",
    desc: "Diese Telefonnummer ist bereits mit einem anderen Konto im Programm verknüpft.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_missing_required",
    title: "Daten fehlen",
    desc: "Bitte überprüfen Sie, ob Sie alle erforderlichen Daten angegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_message_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_map_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_map_address_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_limit_exceeded",
    title: "Du kannst es nicht tun",
    desc: "Dieser Gutschein kann nur einmal eingelöst werden.",
    button: "Prüfe andere Gutscheine",
    returnUrl: "/coupons",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_catalogue_level_locked",
    title: "Ungenügendes Statusniveau",
    desc: "Leider reicht Dein aktueller Status nicht aus, um diesen Coupon einzulösen.",
    button: "Ok",
    returnUrl: "/coupons",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_level_too_low",
    title: "Ungenügendes Statusniveau",
    desc: "Leider reicht Dein aktueller Status nicht aus, um diesen Coupon einzulösen.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_insufficient_permissions",
    title: "Abgemeldet oder Sitzung abgelaufen",
    desc: "Gehen Sie zur Anmeldeseite.",
    button: "Anmelden",
    returnUrl: "/logowanie",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_http_timeout",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuchen Sie es später noch einmal. Wir entschuldigen uns für das Problem.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_http_exception",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_file_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_favourite_catalogue_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuchen Sie es später noch einmal. Wir entschuldigen uns für das Problem.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_favourite_catalogue_already_exists",
    title: "Ein Problem ist aufgetreten",
    desc: "Der Gutschein wurde bereits zu den Favoriten hinzugefügt.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_favourite_address_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuchen Sie es später noch einmal. Wir entschuldigen uns für das Problem.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_favourite_address_limit_exceeded",
    title: "Limit für Lieblingsorte überschritten",
    desc: "Entschuldigung, Sie haben das maximale Limit von 50 Lieblingsorten erreicht. Bitte entfernen Sie einen Eintrag, bevor Sie einen neuen hinzufügen.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_favourite_address_already_exists",
    title: "Ein Problem ist aufgetreten",
    desc: "Der Ort wurde bereits zu den Favoriten hinzugefügt.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_expired_otp",
    title: "Code abgelaufen",
    desc: "Bitte versuchen Sie es erneut und geben Sie den neuen Code ein.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_esc_account_not_found",
    title: "Ein Problem ist aufgetreten",
    desc: "Es scheint, dass wir Ihr neues Konto nicht mit dem alten im eSmoking Club verknüpfen können.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_empty_coupon_database",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_email_address_taken",
    title: "Änderung nicht möglich",
    desc: "Ein Konto mit dieser E-Mail-Adresse existiert bereits. Falls Sie keinen Zugang zum vorherigen Konto haben, versuchen Sie, das Passwort zurückzusetzen, oder kontaktieren Sie uns unter: daneosobowe@bat.com.pl",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_coupon_not_found",
    title: "Gutschein nicht gefunden",
    desc: "Es scheint, als ob der Gutschein nicht mehr im Katalog ist.",
    button: "Prüfe andere Gutscheine",
    returnUrl: "/coupons",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_content_missing",
    title: "Ungültige Daten im Feld",
    desc: "Überprüfen Sie, ob Sie die richtigen Daten für dieses Feld angegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_consumer_not_found",
    title: "Ungültige Daten im Feld",
    desc: "Überprüfen Sie, ob Sie die richtigen Daten für dieses Feld angegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_consumer_migration_required",
    title: "Ungültige Daten im Feld",
    desc: "Überprüfen Sie, ob Sie die richtigen Daten für dieses Feld angegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_consumer_already_migrated",
    title: "Ein Problem ist aufgetreten",
    desc: "Ihr Konto und Ihre Punkte wurden bereits zuvor in den Inspiration Club migriert.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_consumer_already_exists",
    title: "Ein Konto mit diesen Daten existiert bereits",
    desc: "Es sieht so aus, als ob die angegebene E-Mail-Adresse oder Telefonnummer bereits verwendet wird. Wenn Sie keinen Zugriff auf das vorherige Konto haben, versuchen Sie, Ihr Passwort zurückzusetzen, oder kontaktieren Sie uns unter: daneosobowe@bat.com.pl.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_form_consumer_already_exists",
    title: "Ein Konto mit diesen Daten existiert bereits",
    desc: "Es sieht so aus, als ob die von Ihnen angegebene E-Mail-Adresse oder Telefonnummer bereits verwendet wird. Daher können Sie sich nicht für das Inspiration Club-Programm registrieren und von der Werbeaktion profitieren.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_complaint_already_sent",
    title: "Ihre Reklamation wurde bereits gesendet.",
    desc: "Bitte beachten Sie, dass Sie nur eine Reklamation einreichen können. Brauchen Sie zusätzliche Hilfe? <br/>Kontaktieren Sie uns unter: kontakt@service@bat.de",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_catalogue_locked",
    title: "Gutschein gesperrt",
    desc: "Kaufen Sie jetzt auf myglo.com oder vuse.com ein, um diesen Gutschein freizuschalten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_bad_value_of_required",
    title: "Ungültige Daten im Feld",
    desc: "Überprüfen Sie, ob Sie die richtigen Daten für dieses Feld angegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_activation_not_found",
    title: "Etwas ist schiefgelaufen...",
    desc: "Bitte versuche es erneut. Wir bitten vielmals um Entschuldigung für die Unannehmlichkeiten.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_activation_locked",
    title: "Ungültige Daten im Feld",
    desc: "Überprüfen Sie, ob Sie die richtigen Daten für dieses Feld angegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_activation_expired",
    title: "Die Aktivität wurde beendet",
    desc: "Leider sieht es so aus, als ob die Aktivität, die Du versuchst zu beenden, nicht mehr aktiv ist. Prüfe andere Aktivitäten.",
    button: "Siehe andere Aktivitäten",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_input_invalid",
    title: "Ungültige Daten im Feld",
    desc: "Überprüfen Sie, ob Sie die richtigen Daten für dieses Feld angegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_login_failed",
    title: "Anmeldung fehlgeschlagen",
    desc: "Entschuldigung, die Anmeldung ist fehlgeschlagen. Vergewissern Sie sich, dass die eingegebenen Daten korrekt sind, und versuchen Sie es erneut.",
    button: "Schließen",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_update_failed",
    title: "Da ist was schief gelaufen",
    desc: "Bitte versuch’s nochmal oder melde dich nochmal an.",
    button: "OK",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_otp_please_wait",
    title: "Der Code wurde bereits gesendet",
    desc: "Warten Sie eine Minute, bevor Sie einen weiteren Code anfordern.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_wrong_otp",
    title: "Falscher SMS-Code",
    desc: "Überprüfen Sie, ob Sie den Code aus der SMS-Nachricht korrekt eingegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_otp_please_wait_email",
    title: "Der Code wurde bereits gesendet",
    desc: "Überprüfen Sie Ihre E-Mails und geben Sie den Code ein.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_wrong_otp_email",
    title: "Falscher Code",
    desc: "Überprüfen Sie, ob Sie den Code aus der E-Mail korrekt eingegeben haben.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "succes_otp_phone",
    title: "Erfolg",
    desc: "Nummer geändert, Sie werden gleich ausgeloggt.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
    logout: true,
  },
  {
    ident: "error_catalogue_not_found",
    title: "Dieser Gutschein ist nicht verfügbar",
    desc: "Vielleicht möchten Sie sich andere Gutscheine im Katalog ansehen?",
    button: "Gutscheinkatalog",
    returnUrl: "/coupons",
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_catalogue_not_found_auction",
    title: "aukcja jeszcze się nie rozpoczęła",
    desc: "",
    button: "OK",
    returnUrl: "/activities/auction_tokyo_hotel",
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_empty_coupon_database_auction",
    title: "Oops, entschuldige bitte!",
    desc: "Dieses mal war jemand schneller als du und hat die letzte Vuse x Tokio Hotel Signature Edition ergattert. Viel Glück bei der nächsten Auktion.",
    button: "OK",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_limit_exceeded_auction",
    title: "Du hast deine Belohnung bereits erhalten!",
    desc: "Leider kannst du nicht noch einmal bieten, da du deine Vuse x Tokio Hotel Signature Edition bereits erhalten hast.",
    button: "OK",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_periodic_limit_exceeded_auction",
    title: "Du hast deine Belohnung bereits erhalten!",
    desc: "Leider kannst du nicht noch einmal bieten, da du deine Vuse x Tokio Hotel Signature Edition bereits erhalten hast.",
    button: "OK",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },

  {
    ident: "error_wrong_password",
    title: "Das eingegebene Passwort ist falsch.",
    desc: "Vergewissern Sie sich, dass Sie das richtige Passwort eingeben und versuchen Sie es erneut.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_email_change_please_wait",
    title: "Nicht so schnell.",
    desc: "Sie sind bereits dabei, Ihre E-Mail-Adresse zu ändern. Prüfen Sie Ihre E-Mail und schließen Sie den Vorgang ab.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_mobile_change_please_wait",
    title: "Nicht so schnell.",
    desc: "Sie sind bereits dabei, Ihre Rufnummer zu ändern. Überprüfen Sie Ihre SMS und schließen Sie den Vorgang ab.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_mobile_phone_taken",
    title: "Wir können die Änderung nicht vornehmen.",
    desc: "Die von Ihnen eingegebene Telefonnummer ist bereits einem anderen Konto zugeordnet. Bitte überprüfen Sie, ob Sie die richtige Telefonnummer eingegeben haben. Sollte das Problem weiterhin bestehen, kontaktieren Sie uns bitte unter daneosobowe@bat.com.pl.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_consumer_email_mismatch",
    title: "Registrierung erfolglos",
    desc: "Die Telefonnummer, die Sie eingegeben haben, ist mit einem eSmoking Club- oder AlterCloud-Konto mit einer anderen E-Mail-Adresse verknüpft. Aktualisieren Sie die E-Mail-Adresse des eSmoking Club-/AlterCloud-Kontos oder löschen Sie sie und versuchen Sie es dann erneut.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_email_taken",
    title: "Wir können die Änderung nicht vornehmen.",
    desc: "Das Konto mit der von Ihnen eingegebenen E-Mail-Adresse existiert bereits. Wenn Sie keinen Zugang zu Ihrem früheren Konto haben, versuchen Sie bitte, Ihr Passwort zurückzusetzen oder kontaktieren Sie uns unter: daneosobowe@bat.com.pl.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_voucher_please_wait",
    title: "Nicht so schnell - die SMS ist auf dem Weg",
    desc: "Eine SMS mit einem Link zum Abholen des Gutscheins wurde beim letzten Versuch verschickt und ist bereits auf dem Weg zu der Nummer, die Sie zuvor eingegeben haben. Wenn Sie sie nicht innerhalb von 5 Minuten erhalten, überprüfen Sie die eingegebene Telefonnummer und versuchen Sie es erneut.",
    button: "Schließen",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_wrong_user_status",
    title: "Ihr Konto ist jetzt aktiv - Zeit, sich einzuloggen.",
    desc: "Wenn Sie Ihr Passwort vergessen haben, benutzen Sie bitte die Option „Passwort vergessen“, um ein neues Passwort festzulegen.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_token_invalid",
    title: "Ihr Link ist nicht mehr gültig oder ist ungültig",
    desc: "Verwenden Sie die Option „Passwort vergessen“, um einen Link für ein neues Passwort zu erhalten.",
    button: "Ok",
    returnUrl: "/",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_unauthorized",
    title: "Ausgeloggt oder Sitzung abgelaufen.",
    desc: "Rufen Sie die Anmeldeseite auf.",
    button: "Erneut anmelden",
    returnUrl: "/",
    disableClose: false,
    updateUserData: false,
    logout: true,
    custom: [
      {
        id: "consumer-join-details",
        title: "Link nicht mehr gültig.",
        desc: "Zur Startseite gehen.",
        button: "Ok",
        returnUrl: "/",
        disableClose: false,
      },
      {
        id: "consumer-confirm",
        title: "Link nicht mehr gültig.",
        desc: "Zur Startseite gehen.",
        button: "Ok",
        returnUrl: "/",
        disableClose: false,
      },
    ],
  },
  {
    ident: "error_chic_token_expired_or_invalid",
    title: "Ausgeloggt oder Sitzung abgelaufen.",
    desc: "Rufen Sie die Anmeldeseite auf.",
    button: "Erneut anmelden",
    returnUrl: "/",
    disableClose: false,
    updateUserData: false,
    logout: true,
  },
  {
    ident: "error_account_temporary_blocked",
    title: "Ihr Konto wurde vorübergehend gesperrt.",
    desc: '<p>Wir haben ungewöhnliche Aktivitäten auf Ihrem Konto festgestellt. Wir sind gerade dabei, diesen Sachverhalt zu überprüfen und werden uns in Kürze mit Ihnen in Verbindung setzen.</p><p>Wenn Sie Hilfe benötigen, senden Sie bitte eine E-Mail an: <a href="mailto:daneosobowe@bat.com.pl">daneosobowe@bat.com.pl</a><br/>Wir entschuldigen uns für die Unannehmlichkeiten.</p>',
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_account_blocked",
    title: "Ihr Konto wurde vorübergehend gesperrt.",
    desc: '<p>Wir haben ungewöhnliche Aktivitäten auf Ihrem Konto festgestellt. Wir sind gerade dabei, diesen Sachverhalt zu überprüfen und werden uns in Kürze mit Ihnen in Verbindung setzen.</p><p>Wenn Sie Hilfe benötigen, senden Sie bitte eine E-Mail an: <a href="mailto:daneosobowe@bat.com.pl">daneosobowe@bat.com.pl</a><br/>Wir entschuldigen uns für die Unannehmlichkeiten.</p>',
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_m2_already_registered",
    title: "Das Konto mit der angegebenen Adresse existiert bereits.",
    desc: "Wenn Sie ein Konto beim Online-Shop myglo.com oder auf der Plattform You Have a Choice haben, verwenden Sie dieselben Anmeldedaten.  <br/>Versuchen Sie, sich einzuloggen oder klicken Sie auf „Passwort vergessen“, um es zurückzusetzen.",
    button: "Passwort ändern",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_m2_wrong_credentials_or_disabled",
    title: "Die von Ihnen eingegebene E-Mail oder das Passwort sind falsch.",
    desc: "Vergewissern Sie sich, dass Sie Ihre Daten richtig eingegeben haben. Versuchen Sie, sich erneut anzumelden.",
    button: "Erneut anmelden",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_m2_empty_field",
    title: "Es ist ein Fehler aufgetreten.",
    desc: " Versuchen Sie es noch einmal.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_token_has_been_already_used",
    title: "Es ist ein Fehler aufgetreten.",
    desc: "Fahren Sie fort, um das Passwort zurückzusetzen.",
    button: "Erneut anmelden",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_customer_not_found_by_email",
    title: "Es ist ein Fehler aufgetreten.",
    desc: "Beginnen Sie ganz von vorne.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_customer_not_found_by_token",
    title: "Es ist ein Fehler aufgetreten.",
    desc: "Beginnen Sie ganz von vorne.",
    button: "Erneut anmelden",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_already_answered",
    title: "Es ist ein Fehler aufgetreten.",
    desc: "Die Antwort auf die Wettbewerbsfrage ist bereits eingereicht worden.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_max_limit_of_solutions_exceeded",
    title: "Durchgeführte Tätigkeit",
    desc: "Diese Aufgabe ist bereits von Ihnen erledigt worden. Bitte prüfen Sie die anderen Aktivitäten.",
    button: "Schließen",
    returnUrl: "/activities",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_token_expired",
    title: "Da ist was schief gelaufen",
    desc: "Logge dich ein nochmal, um weiterzumachen.",
    button: "Zum Login",
    returnUrl: "/",
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_voucher_already_assigned",
    title: "Es ist ein Fehler aufgetreten.",
    desc: "Die von Ihnen eingegebene Telefonnummer existiert bereits in der Datenbank, bitte versuchen Sie es erneut mit einer neuen Telefonnummer",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_verification_required",
    title: "Wir haben den Zugang zu Ihrem Konto eingeschränkt.",
    desc: '<p>Wir haben ungewöhnliche Aktivitäten in dem Konto festgestellt, in das Sie sich einzuloggen versuchen.* Aus Sicherheitsgründen und zur Überprüfung der Informationen haben wir den Zugang zu dem Konto vorübergehend gesperrt.* Um die Sperrung Ihres Kontos aufzuheben, befolgen Sie bitte die Anweisungen, die wir an Ihre E-Mail-Adresse gesendet haben.</p><p class="disclaimer">* Eine Kontosperrung erfolgt, wenn wir einen Verstoß gegen die Nutzungsbedingungen der Your Choice-Plattform feststellen.  <a href="/assets/regulamin_serwisu_maszwybor.pdf" target="_blank" rel="noopener noreferrer">Weitere Informationen finden Sie hier</a></p>',
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_m2_token_error",
    title: "Ups, da ist etwas schief gelaufen.",
    desc: "<p>Verwenden Sie die Option „Passwort vergessen“, um ein neues Passwort festzulegen.</p>",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_monthly_limit_exceeded", // Po kliknięciu "Dalej" docelowo pokazujemy tax form, przydałby sie projekt. Do uzupełnienia opis poniżej.
    title: "Es ist ein Fehler aufgetreten.",
    desc: "<p><strong>Es ist derzeit nicht möglich, den Preis abzuholen, wir entschuldigen uns für die technischen Probleme.</strong></p>",
    button: "Dalej",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
    customAction: "showTaxForm", // Ident of custom action.
  },
  {
    ident: "error_prize_exception",
    title: "Es ist ein Fehler aufgetreten.",
    desc: "<p><strong>Es ist derzeit nicht möglich, den Preis abzuholen, wir entschuldigen uns für die technischen Probleme.</strong></p>",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "generic",
    title: "Da ist was schief gelaufen",
    desc: "Bitte versuch’s nochmal oder melde dich nochmal an.",
    button: "OK",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_contest_closed",
    title: "Es ist ein Fehler aufgetreten.",
    desc: "Der Wettbewerb ist nicht mehr gültig.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: true,
    updateUserData: false,
  },
  {
    ident: "error_account_restricted",
    title: "Zugangsbeschränkung",
    desc: "Wir haben ungewöhnliche Kontoaktivitäten festgestellt, die gegen die Bedingungen des Treueprogramms verstoßen. Wir haben den Zugang zu bestimmten Kontofunktionen aus Sicherheitsgründen eingeschränkt.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_monthlyBonus_locked",
    title: "Dieser Preis ist nicht verfügbar.",
    desc: "",
    button: "Schließen ",
    returnUrl: "/",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_monthlyBonus_already_purchased",
    title: "Die Auszeichnung ist bereits eingegangen",
    desc: "",
    button: "Schließen ",
    returnUrl: "/",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_subscription_slot_not_found",
    title: "Das ausgewählte Datum ist nicht mehr verfügbar.",
    desc: "Versuchen Sie, eine andere zu wählen.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_subscription_slot_already_used",
    title: "Das ausgewählte Datum ist nicht mehr verfügbar.",
    desc: "Versuchen Sie, eine andere zu wählen.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_subscription_slot_not_available",
    title: "Das ausgewählte Datum ist nicht mehr verfügbar.",
    desc: "Versuchen Sie, eine andere zu wählen.",
    button: "Schließen ",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_subscription_form_limit_exceeded",
    title: "Buchungslimit überschritten.",
    desc: "Jeder Nutzer kann maximal drei Termine buchen.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_daily_limit_exceeded",
    type: "small_popup_random",
    title: "",
    desc: "",
    randomCopy: [
      {
        title: "Ist das Ihre Lieblingsauszeichnung?",
        desc: "Wie wir sehen, wurde es heute bereits an Sie geliefert. Kommen Sie morgen wieder, um es abzuholen, oder stöbern Sie im Katalog und suchen Sie sich etwas ebenso Interessantes aus!",
      },
    ],
    button: "Coupons",
    returnUrl: "/coupons",
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_pack_daily_limit_exceeded",
    title: "<strong>Tägliches</strong> Limit erreicht",
    desc: "Es können maximal 2 Codes pro Tag registriert werden. Kommen Sie morgen wieder hierher.",
    button: "ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_pack_monthly_limit_exceeded",
    title: "Das <strong>Limit</strong> wurde erreicht",
    desc: "Das Limit von 20 Codes für diesen Monat ist bereits ausgeschöpft. Weitere Anmeldungen werden im nächsten Monat möglich sein.",
    button: "ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_pack_not_found",
    title: "<strong>Falscher</strong> Code",
    desc: "Vergewissern Sie sich, dass Sie ihn richtig eingeben und versuchen Sie es erneut.",
    button: "ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_serial_lockdown",
    title: "<strong>Schloss</strong>",
    desc: "Zu viele fehlgeschlagene Code-Registrierungsversuche. Warten Sie und versuchen Sie es in 24 Stunden erneut.",
    button: "ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_serial_invalid",
    title: "<strong>Code-Registrierungsfehler</strong>",
    desc: "Der eingegebene Code ist falsch oder wurde bereits registriert.",
    button: "ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_serial_not_found",
    title: "<strong>Falscher</strong> Code",
    desc: "Vergewissern Sie sich, dass Sie ihn richtig eingeben und versuchen Sie es erneut.",
    button: "ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_serial_already_registered",
    title: "<strong>Falscher</strong> Code",
    desc: "Der Code ist bereits registriert worden.",
    button: "ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
  {
    ident: "error_prize_already_used",
    title: "Das kannst du nicht tun",
    desc: "Die Belohnung wurde bereits von dir eingelöst.",
    button: "Ok",
    returnUrl: null,
    disableClose: false,
    updateUserData: false,
  },
];

export const customActions = {
  showTaxForm: () => {
    console.log("showTaxForm");
  },
};
